import placeholder from "../../assets/images/placeholder.jpg";
export const handleImage = (image) => {
  if (`${image}`?.includes("http")) return image;
  if (image) {
    if (!image.startsWith("/")) image = `/${image}`;
    return `${process.env.NEXT_PUBLIC_MAIN_URL}${image}`;
  }
  return image || placeholder?.src;
};
